module.exports = __webpack_public_path__ + "static/media/imageB.e1e7d451.svg";